var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4048 27.5264L20.9348 32.0564C22.7948 33.9164 25.8148 33.9164 27.6848 32.0564L32.0748 27.6664C33.9348 25.8064 33.9348 22.7864 32.0748 20.9164L27.5348 16.3964C26.5848 15.4464 25.2748 14.9364 23.9348 15.0064L18.9348 15.2464C16.9348 15.3364 15.3448 16.9264 15.2448 18.9164L15.0048 23.9164C14.9448 25.2664 15.4548 26.5764 16.4048 27.5264Z",
    stroke: "#101016",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7344 24.2266C23.1151 24.2266 24.2344 23.1073 24.2344 21.7266C24.2344 20.3459 23.1151 19.2266 21.7344 19.2266C20.3537 19.2266 19.2344 20.3459 19.2344 21.7266C19.2344 23.1073 20.3537 24.2266 21.7344 24.2266Z",
    stroke: "#101016",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2344 29.2266L29.2344 25.2266",
    stroke: "#101016",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.932261795ab1efe5a0ea0214bb3ec3ce.svg";
export { ForwardRef as ReactComponent };